import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from "@mui/material";

const DynamicDialog = ({ open, onClose, title, description, buttons = [] }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent>
        {description && <DialogContentText>{description}</DialogContentText>}
      </DialogContent>

      {buttons.length > 0 && (
        <DialogActions>
          {buttons.map((btn, idx) => (
            <Button
              key={idx}
              onClick={btn.onClick}
              color={btn.color || "primary"}
              variant={btn.variant || "text"}
            >
              {btn.label}
            </Button>
          ))}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default DynamicDialog;
